import { render, staticRenderFns } from "./subscribe-popup.vue?vue&type=template&id=21d8c208&scoped=true&"
import script from "./subscribe-popup.ts?vue&type=script&lang=ts&"
export * from "./subscribe-popup.ts?vue&type=script&lang=ts&"
import style0 from "./subscribe-popup.scss?vue&type=style&index=0&id=21d8c208&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d8c208",
  null
  
)

export default component.exports